module.exports = new __parcel__URL__("icon-payment-white.54e978cf.svg").toString();